<template>
  <div class="main" :style="cssProps">
    <div class="topBar">
      <a
        class="closeColumnBtn"
        @click="closeColumn"
      >
        <img src="@/assets/images/left-arrow.png">
      </a>
      <div class="topBarTitle">
        Yeni Grup
      </div>
    </div>

    <div class="profileContainer">
      <div class="profilePhotoDiv">
        <img
          :src="photoURL"
          class="avatarImg"
        >
        <input
          style="display: none;"
          ref="groupPhotoSelector"
          @input="imageFilesSelected"
          type="file"
          accept="image/*"
        >
        <dropdown
          :is-icon="false"
          :x="-80"
          :y="-200"
          :class-name="'photoDropDown'"
          ref="photoDropDown"
        >
          <template slot="btn">
            <img
              src="@/assets/images/changegroupphoto.png"
              class="photoHover"
            >
          </template>
          <template slot="body">
            <!-- <div class="photoMenuItem">
              Fotoğraf çek
            </div> -->
            <div
              class="photoMenuItem"
              @click="openFileDialog"
            >
              Fotoğraf yükle
            </div>
          </template>
        </dropdown>
      </div>
      <div class="visibleNameRow">
        <div class="nameTitle">
          GRUP ADI
        </div>
        <input
          class="groupName"
          placeholder="Grup adını giriniz"
          v-model="$store.state.group.newGroup.groupName"
        >
      </div>

      <div
        class="proceedCreateGroup"
        v-if="$store.state.group.newGroup.groupName !== ''"
      >
        <div @click="proceedCreateGroup">
          <img src="@/assets/images/oktick.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventbus.js'
import {
  socketOutputMixin
} from '@/mixins/socketOutputMixin.js'
var vm

export default {
  data () {
    return {
      uploadFileObj: {}
    }
  },
  mixins: [socketOutputMixin],
  methods: {
    closeColumn () {
      this.$store.commit('setNewConversationStateTransition', 'slideRight')
      this.$store.commit('setNewConversationViewState', 'newGroupAddContact')
    },

    proceedCreateGroup () {
      if (this.$refs.groupPhotoSelector.files.length > 0) {
        this.uploadGroupImage()
      } else {
        this.sendCreateGroupMessage()
      }
    },

    uploadGroupImage () {
      this.uploadFileObj = JSON.parse(
        JSON.stringify(this.$store.state.message.uploadFileModel)
      )
      this.uploadFileObj.file = this.$refs.groupPhotoSelector.files[0]
      this.uploadFileObj.processId = this.$uuid.v4()
      this.uploadFileObj.uploadUrl = process.env.VUE_APP_UPLOADURL
      EventBus.$emit('heyManagerUploadThisFile', this.uploadFileObj, 'newGroupImageUploaded')
    },

    sendCreateGroupMessage () {
      var newGrp = JSON.parse(JSON.stringify(this.$store.state.group.newGroup))
      newGrp.Type = 'set'
      newGrp.Task = 'create_group'
      newGrp.From = this.$store.state.session.user.UserID
      newGrp.Owner = this.$store.state.session.user.UserID

      newGrp.GroupID = this.$uuid.v4()
      newGrp.GroupName = newGrp.groupName.trim()
      newGrp.Participants = newGrp.participants.map(p => p.UserID)
      newGrp.GroupDescription = ''.trim()
      newGrp.PhotoURL = this.$store.state.group.newGroup.PhotoURL

      newGrp.ConversationID = this.$store.state.conversation.activeConversation.ConversationID

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(newGrp)))
      // EventBus.$emit('reloadUpdatedData')

      this.$store.commit('setNewConversationStateTransition', 'slideRight')
      this.$store.commit('setNewConversationViewState', 'contactList')
      this.$store.state.display.leftColumn.newConversation.isExpanded = false

      this.$refs.groupPhotoSelector.value = ''
    },

    openFileDialog () {
      this.$refs.groupPhotoSelector.click()
    },

    imageFilesSelected () {
      if (this.$refs.groupPhotoSelector.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          vm.$store.state.group.newGroup.PhotoURL = e.target.result
          vm.$refs.photoDropDown.isHidden = true
        }
        reader.readAsDataURL(vm.$refs.groupPhotoSelector.files[0])
      }
    },

    uploadManagerUploadedFile (fileObj) {
      this.$store.state.group.newGroup.PhotoURL = fileObj.resultURL
      this.sendCreateGroupMessage()
    }
  },

  computed: {
    cssProps () {
      return {
        '--topBarColor': this.$config.theme.default.sideMenu.topBarColor,
        '--fontColor': this.$config.theme.default.sideMenu.fontColor,
        '--buttonColor': this.$config.theme.default.sideMenu.buttonColor
      }
    },
    photoURL () {
      let url =
          this.$store.state.group.newGroup.PhotoURL
            ? this.$store.state.group.newGroup.PhotoURL
            : '/images/groupdefault.png'
      return url
    }
  },

  created () {
    vm = this
    EventBus.$on(
      'newGroupImageUploaded',
      this.uploadManagerUploadedFile
    )
  },

  mounted () {
    this.$store.state.group.newGroup.groupName = ''
    this.$store.state.group.newGroup.PhotoURL = ''
  },

  beforeDestroy () {
    EventBus.$off('newGroupImageUploaded')
  }
}

</script>

<style scoped>
  .main {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    display: flex;
    flex-direction: column;
  }

  .topBar {
    background-color: var(--topBarColor);
    height: 80px;
    display: flex;
    align-items: flex-end;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .topBarTitle {
    color: white;
    font-size: 16px;
    font-weight: 700;
    margin: 10px;
    line-height: 40px;
  }

  .closeColumnBtn {
    cursor: pointer;
  }

  .closeColumnBtn>img {
    width: 30px;
    height: 30px;
    margin: 10px;
    margin-left: 20px;
  }

  profileContainer {
    background-color: #eaeceb;
    width: 100%;
    height: 100%;
    overflow: scroll;
  }

  .profilePhotoDiv {
    text-align: center;
    padding-top: 50px;
    position: relative;
  }

  .avatarImg {
    margin: auto;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background-color: #fff;
    cursor: pointer;
    object-fit: cover;
  }

  .visibleNameRow,
  .aboutRow {
    margin-top: 20px;
    background-color: white;
    padding: 20px;
  }

  .nameTitle {
    color: var(--fontColor);
    font-size: 10px;
    font-weight: 700;
    padding-bottom: 10px;
  }

  .photoHover {
    display: block;
    opacity: 0;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    top: calc(50% - 97px);
    left: calc(50% - 110px);
    background-color: RGBA(0, 0, 0, 0.8);
    position: absolute;
    cursor: pointer;
  }

  .photoHover:hover {
    display: block;
    opacity: 1;
  }

  .photoMenuItem {
    padding: 10px;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 1px;
    background-color: white;
    cursor: pointer;
  }

  .groupName {
    width: calc(100% - 20px);
    padding: 10px;
    font-size: 14px;
  }

  .groupName:focus {
    outline: none;
  }

  .proceedCreateGroup {
    height: 0px;
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    justify-content: center;
    transition: height 0.25s ease;
  }

  .proceedCreateGroupVisible {
    height: 50px !important;
    padding: 20px;
  }

  .proceedCreateGroup>div {
    background-color: var(--buttonColor);
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    border-radius: 25px;
    justify-content: center;
    cursor: pointer;
  }

  .proceedCreateGroup>div>img {
    width: 20px;
    height: 20px;
  }

</style>
